import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleOAuth from "./GoogleOAuth";

const GoogleButton = () => {
  return (
    <GoogleOAuthProvider
      clientId={
        "718687236586-pkhipstnagjpp9capa45ud1gbt3lchs8.apps.googleusercontent.com"
      }
    >
      <GoogleOAuth />
    </GoogleOAuthProvider>
  );
};

export default GoogleButton;
